import { useCallback, useState } from 'react';
import { expectArray } from '../../../apiShape.js';
export function useGitHubExportState() {
    const [repositories, setRepositories] = useState([]);
    const [repositoryId, setRepositoryId] = useState('');
    const [installUrl, setInstallUrl] = useState(null);
    const onDataLoaded = useCallback((data) => {
        const repos = expectArray(data?.repositories, 'GitHub repositories');
        setRepositories(repos);
        setRepositoryId(current => repos.some(repo => repo.id === current) ? current : repos[0]?.id ?? '');
        setInstallUrl(data.installUrl && /^https:\/\/github\.com\/apps\/[a-z0-9-]+\/installations\/new$/.test(data.installUrl) ? data.installUrl : null);
    }, []);
    const reset = useCallback(() => { setRepositories([]); setRepositoryId(''); setInstallUrl(null); }, []);
    return { repositories, repositoryId, setRepositoryId, installUrl, onDataLoaded, reset,
        selected: repositories.find(repo => repo.id === repositoryId) };
}
//# sourceMappingURL=useGitHubExportState.js.map